import { useState } from 'react';

import ChevronTopIcon from '@images/chevron-top.svg?react';

import { StyledScrollButton } from './ScrollToTopButton.styles';

const SCROLLED_HEIGHT = 300;

export const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;

    if (scrolled > SCROLLED_HEIGHT) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <StyledScrollButton isVisible={isVisible} onClick={scrollToTop}>
      <ChevronTopIcon />
    </StyledScrollButton>
  );
};
